import React, {useState} from 'react';
import AurButton from '../../../common/aur-button/AurButton';
import AurChipList, {AurChipConfig} from '../../../common/aur-chip/AurChipList';
import AurIcon, {IconNames, IconColors} from '../../../common/aur-icon/AurIcon';

const Chip: React.FC = () => {
  const [chipConfigs, setChipsConfig] = useState([
    {
      id: 1,
      filterName: 'Date Received',
      filterSelection: [{id: 1, value: '2021/11/11 -- 2022/07/08'}],
      showRemove: true,
      onRemove: () => console.log('Remove clicked for Chip 1'),
    },
    {
      id: 2,
      icon: (
        <AurIcon
          size="small"
          icon={IconNames.Search}
          color={IconColors.Custom}
          customClassName="chip-filter-name-icon"
        />
      ),
      filterName: 'FilterName',
      filterSelection: [
        {id: 1, value: 'FilterSelection'},
        {id: 2, value: 'FilterSelection'},
        {id: 3, value: 'FilterSelection'},
        {id: 4, value: 'FilterSelection'},
        {id: 5, value: 'FilterSelection'},
        {id: 6, value: 'FilterSelection'},
      ],
      showRemove: true,
      onRemove: () => console.log('Remove clicked for Chip 2'),
    },
    {
      id: 3,
      icon: (
        <AurIcon
          size="small"
          icon={IconNames.Search}
          color={IconColors.Custom}
          customClassName="chip-filter-name-icon"
        />
      ),
      filterName: 'FilterName',
      filterSelection: [
        {id: 1, value: 'FilterSelection'},
        {id: 2, value: 'FilterSelection'},
      ],
      showRemove: true,
      onRemove: () => console.log('Remove clicked for Chip 3'),
    },
  ]);
  const [hasFilterValueChanged, setHasFilterValueChanged] = useState(false);
  const handleChange = () => {
    setChipsConfig([
      {
        id: 1,
        filterName: 'Date Received',
        filterSelection: [{id: 1, value: '2021/11/11 -- 2022/07/08'}],
        showRemove: true,
        onRemove: () => console.log('Remove clicked for Chip 1'),
      },
      {
        id: 2,
        icon: (
          <AurIcon
            size="small"
            icon={IconNames.Search}
            color={IconColors.Custom}
            customClassName="chip-filter-name-icon"
          />
        ),
        filterName: 'FilterName',
        filterSelection: [
          {id: 1, value: 'FilterSelection'},
          {id: 2, value: 'FilterSelection'},
          {id: 3, value: 'FilterSelection'},
          {id: 4, value: 'FilterSelection'},
        ],
        showRemove: true,
        onRemove: () => console.log('Remove clicked for Chip 2'),
      },
      {
        id: 3,
        icon: (
          <AurIcon
            size="small"
            icon={IconNames.Search}
            color={IconColors.Custom}
            customClassName="chip-filter-name-icon"
          />
        ),
        filterName: 'FilterName',
        filterSelection: [
          {id: 1, value: 'FilterSelection'},
          {id: 2, value: 'FilterSelection'},
        ],
        showRemove: true,
        onRemove: () => console.log('Remove clicked for Chip 3'),
      },
    ]);
    setHasFilterValueChanged(true);
  };
  const handleOnClearAll = () => {
    console.log('clear all clicked');
  };
  const handleOnSave = (config?: AurChipConfig[]) => {
    console.log('onsave clicked', config);
  };
  const handleResetToDefault = () => {
    console.log('handleResetToDefault clicked');
  };
  return (
    <>
      Chip Page Loaded
      <div>
        <AurButton onClick={handleChange} type="text">
          Change chipConfigs value
        </AurButton>
      </div>
      <div>
        <AurChipList
          onResetToDefault={handleResetToDefault}
          onSave={(config) => handleOnSave(config)}
          onClearAll={handleOnClearAll}
          hasFilterValueChanged={hasFilterValueChanged}
          chipConfigs={chipConfigs}
        />
      </div>
    </>
  );
};

export default Chip;
